<template>
  <div class="dashboard-card" :style="{ background: properties.bgColor }">

    <div class="titolo col-24">
      {{ properties.title }}
    </div>
    <div class="col-24 dati">
      <div class="row row-custom">
        <div class="col-6 no-padding" :style="{ color: properties.iconColor }">
          <icon :name="properties.icona" scale="2.9"></icon>
        </div>
        <div class="col-18 no-padding numero" v-if="properties.type === 'Numero'">
          {{ properties.value }}
        </div>
        <div class="col-18 no-padding valore" v-if="properties.type === 'Valore'">
          <div class="euro">{{ properties.valueEuro + ',' }}</div><div class="centesimi">{{ properties.valueCentesimi }}</div>
        </div>
        <div class="col-18 no-padding id-e-data" v-if="properties.type === 'Data'">
          <div class="id col-24 no-padding">{{ properties.id }}</div>
          <div class="data col-24 no-padding">{{ properties.data | formatDate }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'DashboardCard',
    filters: {
      formatDate: function (date) {
        if (date == '') {
          return ' '
        }
        return (date.substr(0, 2) + '/' + date.substr(2, 2) + '/' + date.substr(4, 4))
      }
    },
    props: {
      properties: {
        type: Object,
        required: true,
        default: function () {
          return {
            bgColor: 'red',
            iconColor: 'white',
            title: 'Titolo',
            icona: 'riv-tick',
            type: 'Data',
            id: '12345',
            data: '10.09.2018'
          }
        }
      }
    },
    data () {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .dashboard-card {
    height: 120px;
    border-radius: 4px;
    .titolo {
      height: 40px;
      line-height: 40px;
      .set-font(@size: 18px; @color: @white);
    }
    .dati {
      padding-top: 10px;
      .numero {
        line-height: 65px;
        .set-font(@color: @white; @size: 28px; @family: 'os-light');
        text-align: right;
      }
      .valore {
        line-height: 65px;
        padding: 0px;
        .set-font(@color: @white; @size: 28px; @family: 'os-light');
        text-align: right;
        .euro {
          display: inline-block;
        }
        .centesimi {
          display: inline-block;
          .set-font(@size: 24px; @color: @white; @family: 'os-light');
        }
      }
      .id-e-data {
        text-align: right;
        .id {
          .set-font(@color: @white; @size: 16px);
        }
        .data {
          .set-font(@color: @white; @size: 24px);
          line-height: 24px;
        }
      }
    }
  }

  @media screen and (max-width: 1400px) and (min-width: 1250px) {
    .dashboard-card  {
      .titolo {
        .set-font(@size: 16px; @color: @white);
      }
      .dati {
        .numero {
          .set-font(@color: @white; @size: 23px; @family: 'os-light');
        }
      }
    }
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    .dashboard-card  {
      .titolo {
        .set-font(@size: 15px; @color: @white);
      }
      .dati {
        .numero {
          .set-font(@color: @white; @size: 20px; @family: 'os-light');
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponents/DashboardCard.vue